// extracted by mini-css-extract-plugin
module.exports = {"container":"_1oYUQ-JuhA3bsIhbASmQYT","mainPanel":"_38eDflqGtuDDznj7yKa7k5","selectedPanel":"_3m3HlFEDfLr-4HnZXoOMpo"};